import React from "react";
import * as Icons from "@ant-design/icons";
import { Button, Select, Space } from "antd";

export const IconPicker = ({ ...props }) => {
  // Get all AntD icons
  const iconNames = Object.keys(Icons).filter((name) =>
    name.endsWith("Outlined")
  );

  return (
    <>
      <Space.Compact block>
        <Select
          showSearch
          style={{ width: 300 }}
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
          options={iconNames.map((name) => ({
            value: name,
            label: name,
          }))}
          {...props}
        />
        <Button
          icon={props?.value ? React.createElement(Icons[props?.value]) : <></>}
        />
      </Space.Compact>
    </>
  );
};

export default IconPicker;
